// Some bundlers (incl. Bun dev HMR) replace unknown env vars with boolean false.
// Use logical OR to ignore false/empty values and fall back correctly.
const metaEnv = (import.meta as any)?.env || {};
const procEnv = (typeof process !== "undefined" && (process as any).env) || {};

const env = {
  BLAST_API:
    // Support both Bun and Vite-style public env vars
    metaEnv.BUN_PUBLIC_BLAST_API ||
    metaEnv.VITE_BLAST_API ||
    procEnv.BUN_PUBLIC_BLAST_API ||
    procEnv.VITE_BLAST_API ||
    (globalThis as any).BUN_PUBLIC_BLAST_API ||
    "http://localhost:3333",
  NODE_ENV:
    metaEnv.MODE || metaEnv.NODE_ENV || procEnv.NODE_ENV || "development",
  // Supabase / GoTrue / PostgREST (SDK derives /auth/v1 and /rest/v1 from this base URL)
  SUPABASE_URL:
    (metaEnv.BUN_PUBLIC_SUPABASE_URL ||
      metaEnv.VITE_SUPABASE_URL ||
      procEnv.BUN_PUBLIC_SUPABASE_URL ||
      procEnv.VITE_SUPABASE_URL ||
      (globalThis as any).BUN_PUBLIC_SUPABASE_URL ||
      "http://localhost"),
  SUPABASE_ANON_KEY:
    (metaEnv.BUN_PUBLIC_SUPABASE_ANON_KEY ||
      metaEnv.VITE_SUPABASE_ANON_KEY ||
      procEnv.BUN_PUBLIC_SUPABASE_ANON_KEY ||
      procEnv.VITE_SUPABASE_ANON_KEY ||
      (globalThis as any).BUN_PUBLIC_SUPABASE_ANON_KEY ||
      "dev-anon-key"),
  // PostgREST base (defaults to SUPABASE_URL/rest/v1)
  PGR_BASE:
    metaEnv.VITE_PGR_BASE ||
    procEnv.VITE_PGR_BASE ||
    `${(
      (metaEnv.BUN_PUBLIC_SUPABASE_URL ||
        metaEnv.VITE_SUPABASE_URL ||
        procEnv.BUN_PUBLIC_SUPABASE_URL ||
        procEnv.VITE_SUPABASE_URL ||
        (globalThis as any).BUN_PUBLIC_SUPABASE_URL ||
        "http://localhost"
      ) as string
    ).replace(/\/$/, "")}/rest/v1`,
  // Conduit base (defaults to BLAST_API)
  CONDUIT_BASE:
    metaEnv.VITE_CONDUIT_BASE ||
    procEnv.VITE_CONDUIT_BASE ||
    (metaEnv.BUN_PUBLIC_BLAST_API ||
      metaEnv.VITE_BLAST_API ||
      procEnv.BUN_PUBLIC_BLAST_API ||
      procEnv.VITE_BLAST_API ||
      (globalThis as any).BUN_PUBLIC_BLAST_API ||
      "http://localhost:3333"),
  // Iteration/telemetry retention (UI + runtime store)
  MAX_NODE_ITERATIONS:
    Number(
      (metaEnv.BUN_PUBLIC_MAX_NODE_ITERATIONS ||
        metaEnv.VITE_MAX_NODE_ITERATIONS ||
        procEnv.BUN_PUBLIC_MAX_NODE_ITERATIONS ||
        procEnv.VITE_MAX_NODE_ITERATIONS ||
        (globalThis as any).BUN_PUBLIC_MAX_NODE_ITERATIONS ||
        200) as any
    ) || 200,
};

export default env;
